/**
 * Logic for handling different list states.
 * Certain list states return a much larger amount of data
 * and need different render logic to prevent poor performance.
 */
import { competitionListTimeEnum, ListRenderValues } from "app/utils/const";
export default class ListRenderLogic {
  /**
   * Logic to hide event details for events that are further down the list.
   * To help reduce the amount of DOM nodes on screen at once.
   */
  static hideEventDetails(
    listSize: number,
    competitionIndex: number,
    competitionIsVisible: boolean
  ): boolean {
    return (
      listSize > ListRenderValues.THRESHOLD && !competitionIsVisible // ||
      // (listSize <= 60 && competitionIndex > 40 && !competitionIsVisible)
    );
  }

  /**
   * Logic to check if we should use react-window
   */
  static utilizeWindowList(listSize: number, line: string): boolean {
    return (
      listSize >= ListRenderValues.THRESHOLD ||
      (line === competitionListTimeEnum.ALL && listSize > 10)
    );
  }
}
